export enum Languages {
  ru = 'ru',
  en = 'en',
  kk = 'kk'
}
export const SUPPORTED_LANGUAGES = [Languages.ru, Languages.en, Languages.kk];

/** Подписи языков в переключателях (шапка приложения, шапка лендинга). */
export const LANG_LABELS: Record<Languages, string> = {
  [Languages.ru]: 'РУС',
  [Languages.en]: 'ENG',
  [Languages.kk]: 'ҚАЗ'
};

export const KZ_PHONE_MASK = '+7 (___) ___-__-__';
export const SUPPORT_PHONE = '+77011005775';
export const COMMON_DATE_FORMAT = 'DD.MM.YYYY, HH:mm';
export const WIDTH_FOR_OPENED_NAVBAR = 1140;
